import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { Box } from '@mui/material';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';

import { Header } from 'layouts';

import routePages from 'routes/routes';

import RouteSwitch from 'utils/RouteSwitch';

import './AppLayout.scss';

const AppLayout = () => {
    const { slideIdx, fixedHeaderTheme } = useSelector((state) => state.system);
    const [isOnTop, setIsOnTop] = useState(true);

    useEffect(() => {
        if (slideIdx > 0) {
            setIsOnTop(false);
        } else {
            setIsOnTop(true);
        }
    }, [slideIdx]);

    useScrollPosition(
        ({ prevPos, currPos }) => {
            if (!fixedHeaderTheme) {
                const isShow = currPos.y < 0;
                setIsOnTop(!isShow);
            }
        },
        [isOnTop],
        false,
        false,
        100
    );

    return (
        <Box className="wrapper">
            <BrowserRouter>
                <Header isOnTop={isOnTop} />
                <Box className="mainWrapper">
                    <Box className="contentWrapper">
                        <RouteSwitch routePages={routePages} />
                    </Box>
                </Box>
            </BrowserRouter>
        </Box>
    );
};

export default AppLayout;
